import React from "react";
import { ExternalLink } from "lucide-react";
import CodeBlock from "./CodeBlock";

const GettingStarted = ({ data }) => {
  if (!data) return null;

  return (
    <div id="introduction" className="scroll-mt-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">{data.title}</h1>
      <p className="text-sm text-gray-500 mb-6">{data.subtitle}</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-8">
        <div className="bg-gradient-to-br from-[#048AAD]/5 to-[#048AAD]/10 border border-[#048AAD]/20 rounded-xl p-4">
          <div className="text-xs font-semibold text-[#048AAD] uppercase tracking-wider mb-1">Base URL</div>
          <code className="text-sm font-mono text-gray-800">{data.baseUrl}</code>
        </div>
        <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 border border-amber-200/50 rounded-xl p-4">
          <div className="text-xs font-semibold text-amber-600 uppercase tracking-wider mb-1">Authentication</div>
          <code className="text-sm font-mono text-gray-800">X-API-Key</code>
        </div>
        <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 border border-purple-200/50 rounded-xl p-4">
          <div className="text-xs font-semibold text-purple-600 uppercase tracking-wider mb-1">Rate Limit</div>
          <span className="text-sm text-gray-800">{data.rateLimit}</span>
        </div>
      </div>

      <h3 className="text-base font-bold text-gray-800 mb-4">Quick Start Guide</h3>

      <div className="space-y-0">
        {data.steps.map((step, i) => (
          <div key={i} className="flex gap-4 pb-6 last:pb-0">
            <div className="flex flex-col items-center">
              <div className="w-8 h-8 rounded-full bg-[#048AAD] text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                {step.number}
              </div>
              {i < data.steps.length - 1 && <div className="w-px flex-1 bg-gray-200 mt-2" />}
            </div>
            <div className="flex-1 pt-0.5">
              <h4 className="text-sm font-semibold text-gray-800 mb-1">{step.title}</h4>
              <p className="text-sm text-gray-500 leading-relaxed mb-2">{step.description}</p>
              {step.code && <CodeBlock singleCode={step.code} singleLang="curl" />}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-xl">
        <h4 className="text-sm font-semibold text-blue-800 mb-2">Next Steps</h4>
        <ul className="space-y-1.5 text-sm text-blue-700">
          <li className="flex items-center gap-2">
            <ExternalLink size={12} />
            Explore the Messaging APIs to send text, media, and template messages
          </li>
          <li className="flex items-center gap-2">
            <ExternalLink size={12} />
            Check the Error Reference for troubleshooting common issues
          </li>
          <li className="flex items-center gap-2">
            <ExternalLink size={12} />
            Use the API Playground on the right to test endpoints live
          </li>
        </ul>
      </div>
    </div>
  );
};

export default GettingStarted;
